import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "antd";
import Heading from './Heading';
import GrantScheduleTable from '../../GrantScheduleTable/GrantScheduleTable';
import { ReviewScheduleTable } from '../style';

const ViewRecurSchedule = ({
  title,
  edit,
  handleEdit,
  scheduleData,
}) => {
  return (
    <>
      <Heading title={title} edit={edit} handleEdit={handleEdit} />
      <Row className="view-recurring-schedule">
        <Col md={24}>
          <GrantScheduleTable 
            {...scheduleData}
            Table={ReviewScheduleTable}
            grantNameWidth="50%" />
        </Col>
      </Row>
    </>
  );
};

ViewRecurSchedule.propTypes = {
  title: PropTypes.string,
  edit: PropTypes.bool,
  handleEdit: PropTypes.func,
  scheduleData: PropTypes.object,
}

export default ViewRecurSchedule;
